export function getTypesByCourseTypeLevelId(state, courseTypeLevelI) {
  return getHomeworkTypesState(state) &&
    getHomeworkTypesState(state).filter((type) => type.courseTypeLevelId === courseTypeLevelI);
}

export function getTypeByHomeworkTypeCode(state, code) {
  return getHomeworkTypesState(state) && getHomeworkTypesState(state).get(code);
}

function getHomeworkTypesState(state) {
  return state.get('rootReducer').get('homeworkTypes');
}



// WEBPACK FOOTER //
// ./data/Homework/Types/accessors.js